const common = {
  "user": {
    "unknown": "(不明)"
  },
  "queryState": {
    "imageLoading": "画像を読み込み中",
    "retry": "再試行",
    "loadFailedGeneric": "データを読み込めませんでした",
  },
  "reviewMode": {
    "label": "検収モード",
    "exit": "検収モードを終了",
  },
  "notCompleted": {
    "view3d": "3D(メッシュ)はまだ構築されていません",
    "view2d": "2D(オルソ画像 · DEM)はまだ構築されていません",
    "values": "{{dates}}: 処理がまだ終わっていないため計算しません",
    "issueWrite": "処理がまだ終わっていないため、イシューの座標を保存できません",
    "tools3d": "処理がまだ終わっていないため、イシューの作成と縦断計測は使えません",
    "profile": "処理がまだ終わっていないため、断面は表示できません",
    "coordinates": "処理がまだ終わっていないため、座標は編集できません",
    "write": "処理がまだ終わっていないため、閲覧のみできます",
  },
  "colorPicker": {
    "changeColor": "色の変更: {{target}}",
  },
  "folder": {
    "newFolder": "新規フォルダ",
    "newFolderNamed": "{{name}} に新規フォルダ",
    "createChild": "サブフォルダを作成",
    "rename": "名前を変更",
    "duplicate": "複製",
    "duplicating": "コピー中…",
    "move": "移動",
    "moveToFolder": "フォルダへ移動",
    "moveUp": "上へ移動",
    "moveDown": "下へ移動",
    "delete": "削除",
    "cancel": "キャンセル",
    "root": "最上位",
    "moveTargets": "移動先",
    "nameInput": "フォルダ名",
    "saveName": "名前を保存",
    "cancelName": "編集をキャンセル",
    "itemCount": "{{count}}件",
    "folderMenu": "フォルダメニュー: {{name}}",
    "itemMenu": "項目メニュー: {{name}}",
    "lock": "ロック",
    "unlock": "ロック解除",
    "lockedRow": "ロック中: {{name}}",
    "showToggle": "フォルダを表示: {{name}}",
    "sizePartial": "{{size}} 以上",
    "deleteTitle": "フォルダを削除",
    "deleteMessage": "フォルダ「{{name}}」を削除しますか？",
    "deleteMessageWithSubfolders": "「{{name}}」とそのサブフォルダ（計{{count}}個）を削除しますか？",
    "deleteSubMessage": "中の項目{{count}}件はフォルダの外に移り、データは削除されません。",
    "deleteSubMessageWithItems": "中の項目{{count}}件も一緒に削除されます。",
    "deleteSubMessageNoItems": "フォルダ内に項目がないため、フォルダのみ削除されます。",
    "loadFailedNamed": "{{name}} のフォルダを読み込めませんでした",
    "selectedCount": "{{count}}件選択中",
    "selectionHint": "まとめてドラッグして1つのフォルダに移動できます",
    "selectionMaxed": "一度に移動できる最大数です",
    "clearSelection": "選択を解除",
    "error": {
      "forbidden": "フォルダを変更する権限がありません。",
      "notFound": "対象のフォルダまたは項目が見つかりません。一覧を再読み込みします。",
      "failed": "フォルダの操作に失敗しました。",
      "notSent": "フォルダの操作を送信できませんでした。しばらくしてからもう一度お試しください。",
      "uploadNotPlaced": "アップロードしたファイルをフォルダに入れられなかったため、最上位に置きました。",
      "moveTooMany": "一度に移動できるのは{{max}}件までです。チェックを減らしてからもう一度ドラッグしてください。"
    }
  },
  "projects": {
    "projectInfo": "プロジェクト情報",
    "application": "アプリケーション",
    "projectList": "プロジェクトリスト",
    "checkingApplication": "2D(画像) & 3D(モデル) 点検",
    "portinfraApplication": "港湾インフラ安全点検",
    "slopeAppication": "法面維持管理",
    "constructingApplication": "港湾施設物安全点検",
    "cadastralApplication": "用地管理(Beta)",
    "managingDroneImages": "ドローン画像",
    "droneImages": "ドローン画像マッピング",
    "summaryMapping": "画像マッピング概要",
    "waitingMapping": "マッピング待機",
    "managingProjectGroup": "プロジェクトグループ",
    "managingEtcData": "その他のデータ",
    "roadIssue": "道路舗装問題検出",
    "newProject": "新しいプロジェクト",
    "newProjectCreate": "新規プロジェクト作成",
    "droneImagesCount": "ドローン画像数",
    "droneImageMapping": "画像マッピング",
    "imageMapingProcess": "画像マッピングプロセス",
    "processCondition": "処理状態",
    "orthomosaicDown": "オルソモザイク画像[TIF]",
    "pointcloudDown": "3D点群[LAS]",
    "meshDown": "3Dメッシュ[OBJ]",
    "dsmDown": "数値表面モデル[DSM-TIF]",
    "dataDown": "画像マッピング成果物ダウンロード",
    "message": {
      "failedCreatingContent": "データ作成失敗",
      "deletedContent": "データ削除完了",
      "failedDeletedContent": "データ削除失敗",
      "makeSureDeleteProject": "プロジェクトを削除しますか？",
      "makeSureDeleteTimeSeries": "本当に時系列を削除しますか？",
      "warningDeleteTimeSeries": "この操作は元に戻すことができません。\n 時系列を削除すると、関連するすべてのデータが削除され、イシュー・測定記録・レポートなどすべての情報が完全に削除されます。",
      "processingMapping": "ドローン画像マッピング処理が完了してから確認できます",
      "processingMappingDownload": "ドローン画像マッピング処理が完了してからデータをダウンロードできます",
      "accessDeniedAdmin": "管理者アカウントはアクセスできません",
      "makeSureModifyProject": "プロジェクトを修正しますか？",
      "makeSureDeleteFolder": "フォルダを削除しますか？",
      "successUpload": "アップロード完了",
      "failedUpload": "アップロード失敗",
      "uploadedImage": "アップロードされた画像",
      "refreshAfterUploaded": "アップロードが完了したら更新ボタンを押してください。",
      "imageDeleteCompleted": "画像の削除が完了しました。",
      "imageUpload10": "画像は10枚以上アップロードする必要があります。",
      "notSelectedImage": "画像を選択してください。",
      "deleteCompleted": "削除に成功しました。",
      "failedDeleting": "削除に失敗しました。",
      "typeProjectName": "プロジェクト名を入力してください。",
      "deleteTimeSeries": "時系列削除",
      "ifYouWantToDeleteTimeSeries": "上記の時系列を削除したい場合は",
      "addTimeSeries": "時系列追加",
      "duplicateTimeSeries": "同じ日付の時系列が存在します。",
      "failedCreating": "作成失敗",
      "successCreating": "作成完了"
    }
  },
  "auth": {
    "message": {
      "loginFailed": "ログイン失敗",
      "confirmFailed": "認証失敗",
      "resendingConfirmationCode": "認証コードを再送信しました。",
      "confirmationCodeResendingFail": "再送信失敗",
      "fillEmail": "登録済みのメールアドレスを入力してください。",
      "sendCodeNumber": "認証番号をお送りします。",
      "sentCodeNumber": "認証番号が送信されました。",
      "sendCodeNumberFailed": "認証番号送信失敗",
      "changePassWordFailed": "パスワード変更失敗",
      "notMatchCode": "認証番号は6桁の数字です。"
    }
  },
  "inspection2d": {
    "projectInfo": "プロジェクト情報",
    "projectModify": "プロジェクト情報修正",
    "layerInfo": "レイヤー",
    "issueInfo": "イシュー/測定",
    "managingBim": "3D管理",
    "report": "レポート",
    "mainLayer": "メインレイヤー",
    "issueType": "イシューツール",
    "issueName": "イシュー名",
    "createIssue": "イシュー作成",
    "typeByXY": "X-Y座標",
    "typeByLatLng": "緯度経度座標",
    "issueList": "イシュー一覧",
    "issueDegree": "イシュー程度",
    "msg": {
      "nonNegativeNumber": "高さの値は正の数でなければなりません。",
      "tooSmallArea": "体積情報を求めるための幅が狭すぎます。",
      "notAnyMatchIssue": "一致するイシューがありません。",
      "makeIssue": "イシューを登録してください。",
      "annotaionFixSuccess": "イシュー修正完了",
      "nonAnnotation": "選択されたアノテーションがないか、通信エラーが発生しました。",
      "projectLoading": "プロジェクト読み込み中...",
      "notMyProject": "このプロジェクトへのアクセス権限がありません。",
      "layerLoading": "レイヤー情報読み込み中...",
      "creationAnnotation": "アノテーション作成完了",
      "failedCreationAnnotation": "アノテーション作成失敗",
      "loadingFilterInfo": "フィルタリング情報読み込み中...",
      "successDeleting": "削除に成功しました。",
      "failedDeleting": "削除に失敗しました。",
      "loadingLongitudianlInfo": "断面情報読み込み中...",
      "outOfRangeMessage": "対象地域を外れました。",
      "loadingIssuelInfo": "イシュー情報読み込み中...",
      "errorLoadLongitudinalInfo": "断面情報を読み込めませんでした。",
      "loadingPage": "ページ読み込み中...",
      "loadingData": "データ読み込み中...",
      "loadingAnnotation": "アノテーション読み込み中...",
      "checkPositionByClickingMap": "地図をクリックして座標を確認してください。",
      "loadingMeasurementInfo": "測定情報読み込み中...",
      "noMeasure": "測定情報がありません。",
      "noLength": "高さ情報がありません。",
      "noDSM": "DSM情報がありません。",
      "noLayer": "レイヤーがありません。",
      "pleaseSelectACrossSection": "断面選択",
      "noCrossSection": "対象地域を外れました。",
      "validateStepDigit": "整数2桁、小数点以下1桁以内で入力してください。",
      "validateStepLength": "各線分の長さより間隔を小さく入力してください。",
      "longitudinalIntervalError": "点間隔を整数2桁、小数点以下1桁以内、1m以上で入力してください。",
      "longitudinalWidthError": "左右の幅は点間隔より大きくなければなりません。",
      "startOverEnd": "開始日が終了日より後です。",
      "endBeforeStart": "終了日が開始日より前です。",
      "createdOverStart": "開始日がプロジェクト作成日より前です。",
      "loading3DTiles": "メッシュモデルデータ読み込み中...",
      "loading3DTilesError": "メッシュモデルの読み込みに失敗しました。"
    }
  },
  "inspection3d": {
    "layers": "レイヤー",
    "model": "モデル",
    "issue": "イシュー",
    "measure": "測定",
    "profile": "3D断面プロファイル",
    "distance": "距離",
    "lowQuality": "低解像度",
    "highQuality": "高解像度",
    "opacity": "透明度",
    "msg": {
      "underMaintenance": "機能メンテナンス中",
      "loading3DModel": "3Dモデル作成中",
      "modelServerError": "3Dモデルサーバーエラー。",
      "modelError": "3Dモデル作成失敗。",
      "syncLayer": "レイヤー情報同期中",
      "syncLayerError": "レイヤー情報同期失敗",
      "noModel": "構築されたモデルがありません。",
      "noIssues": "イシューなし",
      "syncIssues": "イシュー同期中",
      "issueLoadError": "イシュー読み込み失敗",
      "issueCreationSuccess": "イシュー作成完了",
      "issueCreationError": "イシュー作成失敗",
      "issueSaveSuccess": "イシュー保存完了",
      "issueSaveError": "イシュー保存失敗",
      "issueDeleteSuccess": "イシュー削除完了",
      "issueDeleteError": "イシュー削除失敗",
      "issueAreaError": "イシュー作成はモデル領域で可能です。",
      "profileAreaError": "断面図作成はモデル領域で可能です。",
      "imageAreaError": "画像確認はモデル領域で可能です。",
      "measurementAreaError": "測定はモデル領域で可能です。",
      "twoPointCountError": "2点以上を作成してください。",
      "threePointCountError": "3点以上を作成してください。",
      "rightClickHint": "右クリックでキャンセル",
      "doubleClickConfirm": "ダブルクリックで確定",
      "profileSectionSummary": "区間{{count}}個 · 全長 {{length}} m",
      "leftClickRemove": "左クリックで削除",
      "clickToLoadImage": "クリックで近くの画像を確認",
      "profileCoordinateLoading": "座標計算中",
      "measurementRightClick": "右クリックで終了",
      "getNearbyImages": "クリックで周辺画像を読み込みます。",
      "switchingTimeSeries": "時系列切り替え中...",
      "loadingModelList": "モデル一覧を確認中...",
      "loadingModelInfo": "3Dモデル情報を読み込み中...",
      "loadingModelTiles": "3Dモデルを描画中...",
      "meshLoadFailed": "{{name}} モデルの読み込みに失敗しました",
      "meshLoadStalled": "一部のデータを読み込めませんでした",
      "meshLoadStalledNamed": "{{names}} のデータを読み込めませんでした",
      "meshLoadAllFailed": "3Dモデルを読み込めませんでした",
      "retry": "再試行",
      "loadingBim": "BIMを読み込み中...",
      "loadingPointCloud": "ポイントクラウドを読み込み中...",
      "loadingGisLayers": "GISレイヤーを読み込み中...",
      "loadingLinearLayers": "線形レイヤーを読み込み中...",
      "stageBim": "BIM",
      "stagePointCloud": "ポイントクラウド",
      "stageGis": "GISレイヤー",
      "stageLinear": "線形レイヤー",
      "stageLoadFailed": "{{name}} の読み込みに失敗したためスキップします",
      "stageLoadStalled": "{{name}} の読み込みが遅いためスキップします",
      "layerLoadFailed": "{{name}} レイヤーを読み込めませんでした"
    },
    "measureAxis": {
      "axisSolid": "立体",
      "axisPlane": "平面",
      "axisHeight": "高さ",
      "axisHorizontal": "水平",
      "axisSolidArea": "立体面積",
      "axisPlaneArea": "平面面積"
    },
    "tooltip": {
      "showHide": "表示/非表示",
      "flyToLayer": "モデルへ移動",
      "flyToMesh": "モデルへ移動",
      "adjustOpacity": "透明度調整",
      "help": {
        "showHide": "レイヤー表示/非表示",
        "flyToLayer": "モデルへ移動",
        "adjustOpacity": "透明度調整"
      }
    }
  },
  "mapTool": {
    "guide": {
      "button": {
        "click": "クリック",
        "doubleClick": "ダブルクリック",
        "rightClick": "右クリック",
        "release": "離す",
        "drag": "ドラッグ",
        "clickPlus": "クリック(＋)",
        "rightClickPoint": "右クリック(点)"
      },
      "action": {
        "createPoint": "点を追加",
        "finish": "完了",
        "cancel": "キャンセル",
        "undo": "元に戻す",
        "removeMeasurement": "計測を削除",
        "nearbyImage": "近くの画像を確認",
        "placeEquipment": "配置",
        "movePoint": "点を移動",
        "removePoint": "点を削除",
        "appendPoint": "末尾に点を追加"
      },
      "precisePending": "高精度で生成中…"
    }
  },
  "graph": {
    "checkCrossSection": "横断面確認",
    "checkLongitudeSection": "縦断面確認",
    "openSectionGraph": "断面グラフを開く: {{target}}",
    "height": "高度",
    "distance": "距離",
    "line": "線形",
    "alignment": "線形",
    "lineLayerNotFound": "選択したレイヤーの線形データが見つかりません。管理者にお問い合わせください。",
    "layerToggleFailed": "レイヤー変更に失敗しました",
    "layerColorChangeFailed": "レイヤーカラー変更に失敗しました",
    "stratum": "地層",
    "designHeight": "計画高",
    "check": "確認",
    "longitudeSection": "縦断面",
    "specificSection": "特定",
    "crossSection": "横断面",
    "crossSectionList": "横断面リスト",
    "perpendicularInterval": "横断間隔",
    "pointInterval": "点間隔",
    "pointSetting": "地点設定",
    "detailSetting": "詳細設定",
    "startPoint": "開始点",
    "endPoint": "終点",
    "section": "区間",
    "sectionStartPoint": "始点",
    "sectionEndPoint": "終点",
    "original": "原本表示",
    "detail": "詳細表示",
    "startPointError": "開始測点は基本値より小さく設定できません。",
    "enterBranch": "地点を入力してください。",
    "validate": {
      "dxfSaveFileDownloadError": "ファイルダウンロード中にエラーが発生しました。もう一度お試しください。",
      "dxfSaveFileGenerateNotice": "ファイル生成がリクエストされました。通常10分以内に完了します。しばらく後にご確認ください。",
      "dxfSaveFileGenerateError": "ファイル生成に失敗しました。しばらく後にもう一度お試しください。",
      "noSavedData": "保存されたデータがありません。",
      "failDeleteData": "データの削除に失敗しました。もう一度お試しください。",
      "savePerpendicular": "横断面が保存されました。",
      "deletePerpendicular": "横断面が削除されました。",
      "existingCrossSection": "既に保存された横断面があります。削除後にもう一度お試しください。",
      "longitudinalPointIntervalMinValue": "は1以上でなければなりません。",
      "perpendicularIntervalMinValue": "は1以上でなければなりません。",
      "perpendicularWidthMinValue": "は1以上でなければなりません。",
      "duplicatePointError": "同じ地点があります。重複する地点を確認してください。",
      "endPointInfo": "終点を入力しないか、終点が線形の長さより長い場合は全体断面を見ることができます。",
      "lngStartPoint": "縦断面の開始測点はTEXTファイルにのみ反映されます。",
      "startStepError": "始点は基本値より小さく設定できません。",
      "endStepError": "終点は始点より小さく設定できません。",
      "sameStepError": "始点と終点は同じにできません。",
      "performanceWarning": "PC性能によってブラウザの応答が遅くなる場合があります。その際は更新後に点間隔を広げるか区間を縮めてご利用ください。",
      "maxStratumFilesSelected": "ファイルは最大3つまで選択できます。",
      "maxStep": "間隔は100以下でなければなりません。",
      "increment": "間隔は5の倍数でなければなりません。",
      "equal": "点間隔は横断間隔以下でなければなりません。",
      "setPoint": "開始点と終点を設定してください",
      "pointAdditionError": "追加地点は開始測点より小さく設定できません。",
      "pointAdded": "特定横断面が追加されました。",
      "pointAdditionFailed": "特定横断面の追加に失敗しました。しばらく後にもう一度お試しください。",
      "pointAdditionTargetFailed": "既にその距離に横断面があります。入力した距離を確認してください。",
      "distanceExceedsSegmentLength": "入力した距離が線分の長さを超えました。",
      "crossSectionDeletionFailed": "横断面の削除に失敗しました。しばらく後にもう一度お試しください。"
    }
  },
  "myPage": {
    "accountInfo": "アカウント情報",
    "quit": "退会",
    "quitAgreement": "退会規約",
    "quitAggrementDescription": {
      "first": "利用者の個人情報は、原則として個人情報の収集・利用目的が達成されたら遅延なく消去します。ただし、他の法令により保管が必要な情報は、法令が定めた期間、別途分離保管後に消去します。",
      "second": "   ア. 消去手続き及び期限 収集・利用目的が達成された個人情報は遅延なく消去され、関連法令に従い保管が必要な場合は別のDBに移され、内部規定及び関連法令を遵守して（個人情報保有・利用期間）一定期間安全に保管後、遅延なく消去されます。この際、DBに移された個人情報は法律による場合を除き他の目的で利用しません。",
      "third": " イ. 消去方法 電子ファイル形式の情報は、復元及び再生できない技術的方法を使用して完全に削除します。紙に出力された個人情報はシュレッダーにかけるか適切な方法により廃棄します。",
      "fourth": "案内事項をすべて確認し、これに同意します。"
    },
    "msg": {
      "atLeastOneSpecialCharacter": "パスワードは最低1つ以上の特殊文字を含む必要があります。",
      "atLeastOneDigit": "パスワードは最低1つ以上の数字を含む必要があります。",
      "passwordLength": "パスワードは8文字以上でなければなりません。",
      "atLeastOneLowerCaseLetter": "パスワードは最低1つ以上の小文字を含む必要があります。",
      "passwordNeedCapital": "パスワードは最低1つ以上の大文字を含む必要があります。",
      "onlyNumber": "数字のみ入力してください。",
      "notEnoughLength": "正しい長さではありません。",
      "checkVerifyingEmail": "メールで送信された認証番号を入力してください。",
      "makeSureQuiteQuestion": "退会しますか？",
      "makeSureQuitDoubleCheck": {
        "ko": "회원 탈퇴를 원하신다면, '계정 삭제' 를 입력해 주세요.",
        "en": "If you wish to withdraw your membership, please enter &quot;Account Deletion",
        "ja": "退会を希望される場合は、'アカウント削除' と入力してください。",
        "checkWord": "アカウント削除"
      },
      "checkDuplicatedEmail": "メールアドレスの重複を確認してください。",
      "idAllowEngNumber": "正しいメールアドレス形式を入力してください。",
      "emailAlreadyExists": "既に存在するIDです。",
      "newtworkError": "ネットワークエラーにより現在重複確認ができません。",
      "usableEmail": "使用可能なメールアドレスです。",
      "notMatchPassword": "パスワードが一致しません。",
      "failedModifiedUser": "会員情報の修正に失敗しました。",
      "warningTypicalform": "形式で入力してください",
      "warningQuitDescription": "退会案内を確認して同意してください。",
      "joinCompleted": "会員登録が完了しました。",
      "accountDeleted": "アカウントが削除されました。"
    }
  },
  "userManagement": {
    "manageProjectPermission": "プロジェクト権限管理",
    "addUser": "ユーザー追加",
    "delete": "削除",
    "joinStatus": "加入状態",
    "joined": "加入",
    "unjoined": "未加入",
    "msg": {
      "userAdding": "変更中です。",
      "userAdded": "ユーザーが追加されました。",
      "userDeleted": "ユーザーが削除されました。",
      "userEdited": "ユーザー権限が修正されました。",
      "confirmUserDelete": "ユーザーをプロジェクトから削除しますか？",
      "errorUserEdit": "ネットワークエラーにより現在修正できません。",
      "errorUserDelete": "ネットワークエラーにより現在削除できません。",
      "projectFirst": "まずプロジェクトを作成してください。",
      "projectsListing": "プロジェクトリスト読み込み中。"
    }
  },
  "header": {
    "service": "サービス",
    "platform": "プラットフォーム",
    "survey": "ドローン測量 / 空間データ加工",
    "plan": "利用プラン",
    "contact": "1:1お問い合わせ",
    "manual": "マニュアル",
    "project": "プロジェクト",
    "myPage": "マイページ",
    "auth": {
      "login": "ログイン",
      "logging": "ログイン中...",
      "logout": "ログアウト",
      "join": "会員登録",
      "sendingcode": "認証番号送信中...",
      "changepw": "パスワード変更",
      "changingpw": "パスワード変更中...",
      "verifyemail": "メール認証"
    }
  },
  "sideNav": {
    "error": {
      "nonProject": "プロジェクトを1つ選択してください。"
    }
  },
  "constants": {
    "text": "テキスト",
    "polygon": "多角形",
    "rectangle": "四角形",
    "marker": "マーカー",
    "severity": "重大度",
    "importance": "重要度",
    "urgenty": "緊急度",
    "imageupload": "画像アップロード",
    "checkall": "全て選択",
    "distance": "距離(m)",
    "height": "高度(m)",
    "pointBim": "ポイントビーム",
    "image": "画像",
    "optimizedImage": "(最適化/原本)",
    "video": "ビデオ",
    "document": "文書",
    "layer": "レイヤー",
    "noLayer": "選択可能なレイヤーがありません。",
    "layerSelect": "レイヤーを選択してください。",
    "projectName": "プロジェクト名",
    "project": "プロジェクト",
    "address": "住所",
    "position": "座標(緯度経度)",
    "infraType": "インフラタイプ",
    "goBack": "戻る",
    "opacity": "透明度",
    "loadingCalInfo": "測定情報読み込み中...",
    "searchAddress": "住所検索",
    "requiredValue": "必須項目です。",
    "handsOnWriting": "直接入力",
    "updatedDate": "修正日",
    "completedDate": "完了日",
    "completed": "完了",
    "objectType": "オブジェクトタイプ",
    "memo": "メモ",
    "tag": "タグ",
    "keyword": "キーワード",
    "cancel": "キャンセル",
    "save": "保存",
    "makeIssueTitle": "イシューのタイトルを入力してください。",
    "modify": "修正",
    "other": "その他",
    "deleting": "削除",
    "delete": "削除する",
    "search": "検索",
    "add": "追加",
    "remove": "削除",
    "issueList": "イシュー一覧",
    "type": "タイプ",
    "beforeProcess": "処理前",
    "processing": "処理中",
    "processCompleted": "処理完了",
    "processFailed": "処理失敗",
    "twoDimensionImage": "2D画像",
    "threeDimensionImage": "3D画像",
    "requestedProcess": "処理リクエスト",
    "checkingRequest": "検収中",
    "coordinateSystem": "出力座標系",
    "resolution": "解像度(GSD)",
    "download": "ダウンロード",
    "update": "更新",
    "downing": "ダウンロード中",
    "checking": "確認中",
    "createFile": "ファイル作成",
    "creating": "作成中",
    "group": "グループ",
    "preview": "プレビュー",
    "none": "なし",
    "edit": "編集",
    "editModeMeasureNotice": "編集モードを終了すると計算値が更新されます",
    "volumeCalculationFailed": "体積計算に失敗しました。もう一度お試しください。",
    "orthomosaicImage": "オルソモザイク画像",
    "gisLayer": "GISレイヤー",
    "subLayer": "補助レイヤー",
    "annotation": "アノテーション",
    "latitude": "緯度",
    "latitudeShorten": "緯度",
    "longitude": "経度",
    "longitudeShorten": "経度",
    "location": "位置",
    "create": "作成",
    "annotationType": "アノテーションタイプ",
    "issueDescription": "イシュー内容",
    "issueDegree": "イシュー程度",
    "issueGrade": "イシュー段階",
    "createIssue": "イシュー作成",
    "date": "日付",
    "createdDate": "作成日",
    "reset": "初期化",
    "check": "確認",
    "filtering": "フィルタリング",
    "totalIssue": "総イシュー",
    "cases": " 件",
    "measurement": "測定",
    "information": " 情報",
    "coordinates": "座標",
    "area": "面積",
    "surfaceArea": "表面積",
    "line": "線分",
    "length": " 長さ",
    "elevationDifference": "高度差",
    "slope": "勾配",
    "volume": "体積",
    "setFloorHeight": "床面高さ(m)",
    "volumeCalculate": "体積計算",
    "volumeBaseMode": "基準面",
    "baseModeCustom": "基準高を直接入力",
    "baseModeTriangulated": "境界点三角網",
    "baseModeMean": "境界点平均高",
    "volumeGuideTitle": "体積計算ガイド",
    "volumeGuideOpen": "体積計算ガイドを開く",
    "close": "閉じる",
    "baseModeCustomDesc": "直接入力した高度で生成した水平面を基準面として体積を計算します。水平面より上は切土量、下は盛土量です。",
    "baseModeTriangulatedDesc": "ポリゴン境界の頂点を結んで三角網(TIN)を形成し、地形勾配に沿う基準面をもとに体積を計算します。",
    "baseModeMeanDesc": "ポリゴン境界の頂点の地形高度を平均した水平面を基準に体積を計算します。",
    "volumeOutOfRasterBounds": "測定領域が地形高度データの範囲外のため、体積を計算できません。",
    "crossSection": "断面",
    "sectionAndCrossSection": "断面 · 横断面",
    "startingSidePoint": "開始測点",
    "setSpacing": "間隔設定",
    "checkTheCrossSection": "断面確認",
    "cutVolume": "CUT(切土量)",
    "fillVolume": "FILL(盛土量)",
    "netVolume": "純体積",
    "settingInterval": "断面間隔(m)",
    "startingSurveyPoint": "開始測点(m)",
    "checkCrossSection": "断面確認",
    "longitudeGraph": "高度プロファイル",
    "longitudeSliderNotice": "右スライダーを使用して高度プロファイルの急激な変化地点を中心にデータ量を調節できます。",
    "longitudeDetailNotice": "グラフで詳しく見たい部分の点間隔を入力し、開始点と終点を選択してください。",
    "perpendicular": "縦横断面",
    "perpendicularGraph": "横断面高度プロファイル",
    "perpendicularWidth": "幅設定",
    "left": "左",
    "right": "右",
    "perpendicularInterval": "横断間隔",
    "longitudeGraphPart": "部分表示",
    "longitudeGraphTotal": "全体表示",
    "total2DLength": "総2D長さ",
    "total3DLength": "総3D長さ",
    "planeDistance": "水平距離",
    "solidDistance": "3D距離",
    "surfaceDistance": "表面距離",
    "planeArea": "水平面積",
    "solidArea": "3D面積",
    "planeDistanceTooltip": "高度を無視し、水平に投影した直線距離です。",
    "solidDistanceTooltip": "2点間の高度差を反映した3D直線距離です。",
    "surfaceDistanceTooltip": "地形（メッシュ）表面の起伏に沿った実際の距離です。",
    "planeAreaTooltip": "高度を無視し、水平に投影した面積です。",
    "solidAreaTooltip": "頂点の高度差を反映して平面でつないだ面積です。",
    "surfaceAreaTooltip": "地形（メッシュ）表面の起伏まで反映した実際の面積です。",
    "upload": "アップロード",
    "totalAmount": "総容量",
    "writer": "作成者",
    "organization": "所属",
    "title": "タイトル",
    "rank": "役職",
    "email": "メールアドレス",
    "permission": "権限",
    "createReport": "レポート作成",
    "id": "ID",
    "username": "名前",
    "no": "番号",
    "phone": "携帯電話番号",
    "major": "分野",
    "job": "職務",
    "mypage": "マイページ",
    "heightProfile": "高度プロファイル",
    "imageList": "画像リスト",
    "total": "総",
    "imagesCounting": "枚",
    "all": "全体",
    "near": "近く",
    "noneImages": "画像がありません。",
    "loadingImages": "画像読み込み中",
    "requestMapping": "リクエスト",
    "requestCompleted": "リクエスト完了",
    "password": "パスワード",
    "doubleCheck": "パスワード確認",
    "linkPositions": "位置連携",
    "idDoubleCheck": "重複確認",
    "user": "ユーザー",
    "submit": "確認",
    "resend": "再送信",
    "next": "次へ",
    "code": "認証番号",
    "filter": "フィルター",
    "apply": "適用",
    "acquired": "撮影日"
  },
  "pdf": {
    "author": "作 成 者",
    "organization": "所 属",
    "rank": "職 務",
    "email": "メール",
    "report": " レポート",
    "groupAssociations": "グループ連携",
    "issue": "イシュー",
    "issueName": "イシュー名",
    "count": "件",
    "layout": "配置図",
    "summary": "概要",
    "issueLevel": "イシュー程度",
    "issueType": "イシュータイプ",
    "issuePriority": "優先順位",
    "comment": "意見",
    "acquired": "データ取得日",
    "msg": {
      "loadingPdf": "PDF読み込み中..."
    }
  },
  "pricing": {
    "standard1": "月額サブスクリプション方式",
    "standard1_2": "(画像重複度80%以上維持)",
    "standard2": "ドローン画像3000枚 / ドロープロジェクト構築",
    "standard3": "月2回データ処理",
    "standard4": "画像マッピング成果物ダウンロード",
    "advanced1": "年間サブスクリプション方式で各種使用オプションを柔軟に協議",
    "advanced1_2": "",
    "contactUs": "お問い合わせ",
    "title": "DroneSquareサービスプラン",
    "description1": "DroneSquareが提供する正確なデータ分析で現場をモニタリングし、",
    "description2": "最適なメンテナンスを実現してください。",
    "standard_subtitle": "少数の対象物(現場)を分析・管理したい場合",
    "advanced_subtitle": "多数の対象物(現場)を分析・管理したい場合"
  }
} as const;

export default common;
